import type { StatementProps } from '@hooks/useAllRequestedStatements';

import { STATUS } from '../../types/layout';

export type ChipColorType = 'primary' | 'neutral' | 'success' | 'warning' | 'error';

export const isActive = (status: StatementProps['status']) => status === 'generated';

export const STATUS_LABEL: Record<STATUS, string> = {
	[STATUS.DataRequested]: 'generating',
	[STATUS.Created]: 'generating',
	[STATUS.Generated]: 'ready',
	[STATUS.Failed]: 'failed',
	[STATUS.Expired]: 'expired',
};

export const STATUS_COLOR: Record<STATUS, ChipColorType> = {
	[STATUS.DataRequested]: 'neutral',
	[STATUS.Created]: 'neutral',
	[STATUS.Generated]: 'success',
	[STATUS.Failed]: 'error',
	[STATUS.Expired]: 'error',
};
